module.exports = __webpack_public_path__ + "img/rus.1c6fe0b0.svg";